import { Box, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import { BulkAssignGoalTemplateJobCreatedByFragment } from "apps/web/src/types";
import { TWTabGroup } from "../../../componentLibrary/TWTabGroup/TWTabGroup";
import { CreatedByMultiselect } from "./CreatedByMultiselect";

type BulkAssignGoalTemplateStatusProps = {
  tabs: string[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  hasData: boolean;
  queryText: string;
  setQueryText: (text: string) => void;
  selectedCreatedByUsers: BulkAssignGoalTemplateJobCreatedByFragment[];
  setSelectedCreatedByUsers: (users: BulkAssignGoalTemplateJobCreatedByFragment[]) => void;
  refetchBulkAssignmentStatus: () => void;
};

export const BulkAssignGoalTemplateStatusHeader = ({
  tabs,
  selectedTab,
  setSelectedTab,
  hasData,
  queryText,
  setQueryText,
  selectedCreatedByUsers,
  setSelectedCreatedByUsers,
  refetchBulkAssignmentStatus,
}: BulkAssignGoalTemplateStatusProps) => {

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%" }}>
      <TWTabGroup tabs={tabs} onSelected={setSelectedTab} outsideSelected={selectedTab} />
      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignItems: "flex-end" }}>
        {hasData && (<>
          <CreatedByMultiselect
            searchText={""}
            selectedUsers={selectedCreatedByUsers}
            onChangeSelectedUsers={setSelectedCreatedByUsers}
            sx={{ minWidth: 200 }}
          />
          <TextField
            id="search-by-goal-configuration-template-name"
            sx={{ width: 300 }}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={queryText}
            onChange={e => setQueryText(e.target.value)}
          />
        </>)}
        <Button
          onClick={() => refetchBulkAssignmentStatus && refetchBulkAssignmentStatus()}
          variant="outlined"
          startIcon={<RefreshIcon />}
        >
          Refresh
        </Button>
      </Box>
    </Box>
  );
};
